/* eslint-disable */
import Ini from "./ini";
import fileSys from "./fileSystem";
import { EOL } from "../shared/consts";
import { isPlainObject } from "../shared/utils";
export const iniReader = (path) => {
  try {
    return Ini.ini.parseSync(path);
  } catch (e) {
    return undefined;
  }
};

export const iniWriter = (path, obj) => {
  let ini = "";
  if (isPlainObject(obj)) {
    for (let section in obj) {
      ini += "[" + section + "]" + EOL;
      for (let key in obj[section]) {
        ini += key + "=" + obj[section][key] + EOL;
      }
    }
  } else if (typeof obj === "string") {
    ini = obj;
  } else {
    return false;
  }
  try {
    ini = ini.trim();
    fileSys.writeFileSync(path, ini);
    return true;
  } catch (e) {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/fileoprators/iniReaderWriter.js